import { useConfig } from 'shared/config/ConfigContext';
import { EmptyWarningImage } from '@/components/emptyWarning/EmptyWarningImage';
import type { Filters } from '@/interfaces';
import { addResultPageFiltersToUrl } from '@/lib/utils/queryParamFilterConversions';

interface Props {
    filters: Filters;
}

export const NoHotelWarning = ({ filters }: Props) => {
    const { contextPathPP } = useConfig();

    return (
        <div className="text-center mt-64" data-testid="noHotelWarning">
            <h1>404</h1>
            <p>Hotellet du prøver å finne ser ikke ut til å finnes.</p>
            <p>
                Gå <a href={addResultPageFiltersToUrl(`${contextPathPP}/resultat`, filters)}>tilbake til resultatsiden</a> for å se andre
                alternativer.
            </p>
            <div className="mx-auto my-64">
                <EmptyWarningImage />
            </div>
        </div>
    );
};
